import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { statNumberToString } from "../../../../apis/transform/stats"
import yellowCard from "@assets/images/yellow-card.png"
import redCard from "@assets/images/red-card.png"
import Image from "next/image"
import style from "./style.module.scss"
import cx from "classnames"

export function PlayerFouls({
  fouls,
  concededFouls,
  yellowCards,
  redCards,
}: {
  fouls: number
  concededFouls: number
  yellowCards: number
  redCards: number
}) {
  return (
    <div className={style.playerFoulsContainer}>
      <Row className={style.playerFoulsRow}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <Image src={yellowCard} alt={"Ammonizioni"} width={16} height={22} />
            <dt className={style.ml}>Ammonizioni</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{yellowCards}</dd>
          </Col>
        </dl>
      </Row>
      <Row className={cx(style.playerFoulsRow, style.whiteBg)}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <Image src={redCard} alt={"Espulsioni"} width={17} height={22} />
            <dt className={style.ml}>Espulsioni</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{redCards}</dd>
          </Col>
        </dl>
      </Row>
      <Row className={style.playerFoulsRow}>
        <dl>
          <Col xs={6} sm={6} md={3} lg={3} xl={3} className={style.label}>
            <dt>Falli Fatti</dt>
          </Col>
          <Col xs={6} sm={6} md={3} lg={3} xl={3} className={style.value}>
            <dd>{fouls}</dd>
          </Col>
          <Col xs={6} sm={6} md={3} lg={3} xl={3} className={style.label}>
            <dt>Falli Subiti</dt>
          </Col>
          <Col xs={6} sm={6} md={3} lg={3} xl={3} className={style.value}>
            <dd>{concededFouls}</dd>
          </Col>
        </dl>
      </Row>
    </div>
    // <Col className={"colStats"}>
    //   <Row className={"bottomBorder paddingBottom20"}>
    //     <Col sm={6} className={"centerColumn"}>
    //       <Row>
    //         <Col className={"centerColumn"}>
    //           <Row>
    //             <Col className={"competitionSeasonValueLarge"}>{statNumberToString(fouls)}</Col>
    //           </Row>
    //           <Row>
    //             <Col className={"competitionSeasonLabel"}>
    //               <h2>Falli fatti</h2>
    //             </Col>
    //           </Row>
    //         </Col>
    //       </Row>
    //     </Col>
    //     <Col sm={6} className={"centerColumn"}>
    //       <Row>
    //         <Col className={"centerColumn"}>
    //           <Row>
    //             <Col className={"competitionSeasonValueLarge"}>{statNumberToString(concededFouls)}</Col>
    //           </Row>
    //           <Row>
    //             <Col className={"competitionSeasonLabel"}>
    //               <h2>Falli subiti</h2>
    //             </Col>
    //           </Row>
    //         </Col>
    //       </Row>
    //     </Col>
    //   </Row>
    //   <Row className={"paddingTop20"}>
    //     <Col sm={12} className={"centerColumn"}>
    //       <Row>
    //         <Col sm={6} className={"centerColumn"}>
    //           <Row>
    //             <Col>
    //               <Image src={yellowCard.src} alt={"Ammonizioni"} layout={"intrinsic"} width={22} height={30} />
    //             </Col>
    //           </Row>
    //           <Row>
    //             <Col className={"competitionSeasonValue"}>{statNumberToString(yellowCards)}</Col>
    //           </Row>
    //           <Row>
    //             <Col className={"competitionSeasonLabel"}>
    //               <h2>Ammonizioni</h2>
    //             </Col>
    //           </Row>
    //         </Col>
    //         <Col sm={6} className={"centerColumn"}>
    //           <Row>
    //             <Col>
    //               <Image src={redCard.src} alt={"Espulsioni"} layout={"intrinsic"} width={22} height={30} />
    //             </Col>
    //           </Row>
    //           <Row>
    //             <Col className={"competitionSeasonValue"}>{statNumberToString(redCards)}</Col>
    //           </Row>
    //           <Row>
    //             <Col className={"competitionSeasonLabel"}>
    //               <h2>Espulsioni</h2>
    //             </Col>
    //           </Row>
    //         </Col>
    //       </Row>
    //     </Col>
    //   </Row>
    // </Col>
  )
}
